module.exports = __webpack_public_path__ + "static/media/fellowship-2.6f0f5efd.jpg";